import { dispatchAction } from '@ardoq/rxbeach';
import { LoadedState } from '@ardoq/api-types';
import { viewpointNavigatorCommands } from 'viewpointNavigator/viewpointNavigatorCommands';
import { navigate } from 'router/declarative/streamRouterAdapter/actions';
import { OnButtonClick } from './types';

const getEditDatasetAction =
  (loadedState?: LoadedState): OnButtonClick =>
  () =>
    loadedState && viewpointNavigatorCommands.editBlock(loadedState);

const getOpenManageFieldsModalAction =
  (workspaceId?: string): OnButtonClick =>
  () =>
    workspaceId &&
    dispatchAction(
      navigate({
        route: '/workspace-manager/:workspaceId/metamodel/fields',
        params: {
          workspaceId: workspaceId,
        },
      })
    );

export const emptyStateCommands = {
  getEditDatasetAction,
  getOpenManageFieldsModalAction,
};
